
























































































































































































































































































import { Component, Emit, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import {number} from '@coders-tm/vue-number-format';
import DNumberbox from "@/components/DNumberbox/numberbox.vue";

@Component({
  name: 'BlockInputs',
  components: {
    number,
    DNumberbox
  }
})
export default class  extends Vue {
  @PropSync('presets') public localPresets!: any;
  @PropSync('portion') public mainBlock!: any;
  @PropSync('secondaryPortion') public secondaryBlock!: any;
  @Prop({default: true}) public showPower!: boolean;
  @Prop() public periodName!: string;
  @Prop() public blockAccept!: any;
  @Prop() public blockId!: string;
  @Prop({default: false}) public editingBlock!: boolean;
  @Prop({default: () => {
    return {
      first: false,
      second: false,
      third: false,
      fourth: false,
      fifth: false,
      sixth: false,
    }
  }}) public rowVisible!: any;
  @Prop({default: false}) public strictTariffCalc!: boolean;

  public initiated: boolean = false;

  public number_format = {
    decimal: '.',
    separator: ' ',
    prefix: '',
    precision: 2,
  };

  public keys = [
    {id: 1, name: 'first'},
    {id: 2, name: 'second'},
    {id: 3, name: 'third'},
    {id: 4, name: 'fourth'},
    {id: 5, name: 'fifth'},
    {id: 6, name: 'sixth'},
  ]

  get route() {
    return this.$route.name
  }

  get readOnly() {
    if(this.blockAccept) {
      return true;
    } else {
      return false;
    }
  }

  get isReadOnly() {
    return this.strictTariffCalc;
  }

  get show_volume() {
    if((this.localPresets.losses_show_volume && this.route === 'losses')  || (this.localPresets.buy_show_volume && this.route === 'buy') ||
    (this.localPresets.sale_show_volume && this.route === 'sale') || (this.localPresets.transport_cost_show_volume && this.route === 'transport_cost') ||
    (this.localPresets.transport_gain_show_volume && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get show_cost() {
    if((this.localPresets.buy_show_cost && this.route === 'buy') || (this.localPresets.sale_show_cost && this.route === 'sale') ||
    (this.localPresets.transport_cost_show_cost && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_cost && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }    

  get show_cost_delta() {
    if((this.localPresets.buy_show_cost_delta && this.route === 'buy') || (this.localPresets.sale_show_cost_delta && this.route === 'sale') ||
    (this.localPresets.transport_cost_show_cost_delta && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_cost_delta && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get show_cost_total() {
    if((this.localPresets.buy_show_cost_total && this.route === 'buy') || (this.localPresets.sale_show_cost_total && this.route === 'sale') ||
    (this.localPresets.transport_cost_show_cost_total && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_cost_total && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get show_price() {
    if((this.localPresets.buy_show_price && this.route === 'buy') || (this.localPresets.sale_show_price && this.route === 'sale') ||
    (this.localPresets.transport_cost_show_price && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_price && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get show_price_total() {
    if((this.localPresets.buy_show_price_total && this.route === 'buy') || (this.localPresets.sale_show_price_total && this.route === 'sale') ||
    (this.localPresets.transport_cost_show_price_total && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_price_total && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get rowHeight() {
    if(this.route === 'losses') return {height: `220px`,}
    let count = 2;
    for(let key in this.rowVisible) {
      if(this.rowVisible[key]) count += 1;
    }
    return {height: `${(25 * count) + 22}px`,}
  }

  mounted() {
    this.initiated = true;
    this.seekChanges();
  }

  focusInNumberBox(data: any, e:any) {
    data.isFocused = true;
    this.mainBlock= { ...this.mainBlock };
    let inputEl = e.element.querySelector(".dx-texteditor-input");
    Vue.nextTick(() => {
      inputEl.selectionStart = 0;
      inputEl.selectionEnd = inputEl.value.length;
    })
  }

  focusOutNumberBox(data:any) {
    data.isFocused = false;
    this.mainBlock= { ...this.mainBlock };
  }

  correctFormat(e:any) {
    let inputEl = e.element.querySelector(".dx-texteditor-input");
    inputEl.addEventListener('paste', (event:any) => {
      event.preventDefault();
      //@ts-ignore
      let paste = (event.clipboardData || window.clipboardData).getData('text');
      paste = paste.replace(".", ",");
      inputEl.value = paste;
    })
  }

  @Watch('mainBlock.first', { deep: true })
  @Watch('mainBlock.second', { deep: true })
  @Watch('mainBlock.third', { deep: true })
  @Watch('mainBlock.fourth', { deep: true })
  @Watch('mainBlock.fifth', { deep: true })
  @Watch('mainBlock.sixth', { deep: true })
  seekChanges() {
    if(this.initiated) {
      const changes = {block: this.blockId, period: this.periodName};
      this.$emit('changes', changes);
    }
  }

}
